angular.module("vgresiduos").factory("featureAccessService", [
	"accountService",
	function (accountService) {
		"use strict";

		const _hasResiduesManagementModule = function () {
			return isAllowedToFeature(Vgr.enumerations.systemFeatures.residuesManagement);
		};

		const _hasSupplierViewModule = function () {
			return isAllowedToFeature(Vgr.enumerations.systemFeatures.supplierView);
		};

		const _hasPGRSModule = function () {
			return isAllowedToFeature(Vgr.enumerations.systemFeatures.PGRS);
		};

		const _hasExecutiveReportsFeature = function () {
			return isAllowedToFeature(Vgr.enumerations.systemFeatures.executiveReports);
		};

		const _hasDnitIntegrationFeature = function () {
			return isAllowedToFeature(Vgr.enumerations.systemFeatures.dnitIntegration);
		};

		const _hasIbamaRappIntegrationFeature = function () {
			return isAllowedToFeature(Vgr.enumerations.systemFeatures.ibamaRappIntegration);
		};

		function isAllowedToFeature(featureId) {
			const currentOrganizationUnit = accountService.getCurrentClient();
			if (!currentOrganizationUnit) {
				return false;
			}
			const features = (currentOrganizationUnit.organization.features ?? []).map((f) => f.toUpperCase());
			return features.includes(featureId.toUpperCase());
		}

		return {
			hasResiduesManagementModule: _hasResiduesManagementModule,
			hasSupplierViewModule: _hasSupplierViewModule,
			hasPGRSModule: _hasPGRSModule,
			hasExecutiveReportsFeature: _hasExecutiveReportsFeature,
			hasDnitIntegrationFeature: _hasDnitIntegrationFeature,
			hasIbamaRappIntegrationFeature: _hasIbamaRappIntegrationFeature
		};
	}
]);
